import cx from 'classnames'
import { FC, useMemo } from 'react'
import { BlockTitleProps } from 'src/components/BlockTitle'
import { PortraitProps } from 'src/components/Portrait'
import { motionGroup, slideReveal } from 'src/hooks/useAppear'

import * as SC from './styled'

export type TalentsProps = {
  className?: string
  portraits: PortraitProps[]
  blockTitleProps?: BlockTitleProps
  color?: string
  limit?: number
}

const Talents: FC<TalentsProps> = ({
  className,
  portraits,
  blockTitleProps,
  color,
  limit = 3,
}) => {
  const { motions, variants } = useTalentsMotion()

  return portraits && portraits.length > 0 ? (
    <SC.Container className={cx('Talents', className)}>
      {blockTitleProps && <SC._BlockTitle {...blockTitleProps} color={color} />}
      <SC.Wrapper {...motions.slider}>
        <SC._Slider
          slides={portraits.slice(0, limit).map((portrait, index) => {
            return {
              node: (
                <SC.PortraitWrapper
                  key={`portrait-${index}`}
                  variants={variants.portrait}
                >
                  <SC._Portrait
                    key={index}
                    {...portrait}
                    color={color}
                    fullscreenOnMobile={false}
                    role="listitem"
                  />
                </SC.PortraitWrapper>
              ),
            }
          })}
          keenOptions={{
            drag: true,
            slides: { perView: 1.08333, spacing: 16 },
            defaultAnimation: {
              duration: 300,
            },
            breakpoints: {
              // 600 as in sizes
              '(min-width: 37.5em)': {
                slides: { perView: 1.75, spacing: 16 },
              },
              // // 900 as in sizes
              '(min-width: 56.25em)': {
                disabled: true,
              },
            },
          }}
        />
      </SC.Wrapper>
    </SC.Container>
  ) : null
}

const useTalentsMotion = () => {
  const motions = useMemo(
    () => ({
      slider: motionGroup({ staggerChildren: 0.12 }).motionProps,
    }),
    []
  )

  const variants = useMemo(
    () => ({
      portrait: slideReveal({}),
    }),
    []
  )

  return { motions, variants }
}

export default Talents
